var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSymbolPentoolShort(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 121,
    viewBox: "0 0 121 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.544922 30.2344C0.544922 13.6658 13.9764 0.234375 30.5449 0.234375H90.5449C107.113 0.234375 120.545 13.6658 120.545 30.2344V90.2344C120.545 106.803 107.113 120.234 90.5449 120.234H30.5449C13.9764 120.234 0.544922 106.803 0.544922 90.2344V30.2344Z",
    fill: "url(#paint0_linear_219_4774)",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.345 47.7787L72.9842 31.3961C71.442 29.8467 68.7375 29.848 67.1981 31.3949L61.745 36.8553C60.9713 37.6274 60.5452 38.6567 60.5452 39.7528C60.5452 40.849 60.9713 41.8783 61.7437 42.6491L78.106 59.0331C78.877 59.8078 79.9051 60.2345 80.9996 60.2345C82.0942 60.2345 83.1223 59.8078 83.892 59.0345L89.3451 53.574C90.1188 52.802 90.5449 51.7725 90.5449 50.6765C90.5449 49.5803 90.1187 48.5508 89.345 47.7787Z",
    fill: "url(#paint1_linear_219_4774)",
    fillOpacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6036 45.3889C60.1562 44.9401 59.461 44.8602 58.927 45.1904C54.9453 47.6314 48.7077 50.5411 41.602 50.5411C40.9935 50.5411 40.4581 50.9446 40.2904 51.5306L30.5972 85.4577C30.4253 86.0623 30.6877 86.7054 31.2337 87.0171C31.7783 87.3247 32.4681 87.2276 32.8996 86.7681L49.1205 69.5934C49.6651 69.0154 49.9222 68.2019 49.8249 67.3601C49.6371 65.7142 50.3909 64.2133 51.8397 63.3464C53.1127 62.5873 54.8026 62.6247 56.0557 63.4357C57.1411 64.1428 57.8122 65.2228 57.9426 66.4759C58.0718 67.7103 57.643 68.9208 56.7668 69.7971C55.8892 70.6747 54.6747 71.0914 53.4149 70.9516C52.556 70.8503 51.7677 71.1087 51.1871 71.6587L34.0116 87.8801C33.5549 88.3115 33.4523 88.9987 33.7626 89.546C34.0104 89.9801 34.467 90.2344 34.9478 90.2344C35.0717 90.2344 35.1981 90.2171 35.322 90.1825L69.2488 80.4892C69.8347 80.3213 70.2383 79.786 70.2383 79.1775C70.2383 72.0717 73.1479 65.8341 75.5889 61.8524C75.9179 61.3157 75.8367 60.6219 75.3905 60.1757L60.6036 45.3889Z",
    fill: "url(#paint2_linear_219_4774)",
    fillOpacity: 0.7
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_219_4774",
    x1: 60.5449,
    y1: 0.234375,
    x2: 60.5449,
    y2: 120.234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9EBFF",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_219_4774",
    x1: 60.5449,
    y1: 30.2344,
    x2: 60.5449,
    y2: 90.2344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9EBFF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9EBFF",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_219_4774",
    x1: 60.5449,
    y1: 30.2344,
    x2: 60.5449,
    y2: 90.2344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9EBFF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9EBFF",
    stopOpacity: 0.6
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolPentoolShort);
export default __webpack_public_path__ + "static/media/symbol-pentool-short.53cba3434431b8c512607dbb304cfa8b.svg";
export { ForwardRef as ReactComponent };